export default from './external-link';



// WEBPACK FOOTER //
// ./app/components/external-link/index.js